import api from './api'

// const resource = '/auth'
api.defaults.headers.common['x-access-token'] = localStorage.getItem('accessToken');

export default {
    login(params) {
        return api.post(`/auth/login`, params);
    },
    get() {
        return api.get(`/profile`);
    },
    profile(params) {
        return api.post(`/profile/update`, params);
    },
    password(params) {
        return api.put(`/profile/password`, params);
    },
    photo(params) {
        return api.post(`/apps/profile/photo`, params, {
            onUploadProgress: progressEvent => {
              console.log(progressEvent.loaded / progressEvent.total)
            }
          });
    },
    getUsers(page, q) {
        return api.get(`/users?page=${page}&q=${q}`);
    },
    getAllUsers(author) {
        return api.get(`/users?per_page=100&author=${author}`);
    },
    updateUser(id, params) {
        return api.put(`/users/${id}`, params);
    },
    createUser(params) {
        return api.post(`/users`, params);
    },
    deleteUser(id) {
        return api.delete(`/users/${id}`);
    },
    getUser(npp) {
        return api.get(`/users/${npp}`);
    }
}